/**
 * OUTGOING MESSAGE MAPPERS — DTO REST <-> modello UI.
 *
 * SYNC CROSS-LAYER con OutgoingMessageStatus.java
 * (modules/crm-util/src/main/java/it/dvel/crm/util/constants/OutgoingMessageStatus.java):
 * aggiungendo o rinominando uno stato vanno aggiornati in parallelo l'enum Java, le tabelle qui
 * sotto, `OUTGOING_MESSAGE_STATUSES` in outgoingMessageTypes e le chiavi
 * `outgoingMessage.statuses.*` di it.json ed en.json.
 */

import type { OutgoingMessage, OutgoingMessageStatus } from './outgoingMessageTypes';

const STATUS_TO_INT: Record<OutgoingMessageStatus, number> = {
  pending: 0,
  sent: 1,
  cancelled: 2,
  failed: 3,
};

const STATUS_FROM_INT: Record<number, OutgoingMessageStatus> = {
  0: 'pending',
  1: 'sent',
  2: 'cancelled',
  3: 'failed',
};

/** int -> stato con fallback 'pending' e warn per un valore che il frontend non conosce. */
function statusFromInt(value: number | null | undefined): OutgoingMessageStatus {
  const mapped = value == null ? undefined : STATUS_FROM_INT[value];
  if (mapped !== undefined) return mapped;
  console.warn(`[outgoingMessageMappers] Unexpected OutgoingMessage.status value from DTO: ${value}, falling back to 'pending'`);
  return 'pending';
}

export function outgoingMessageStatusToInt(status: OutgoingMessageStatus): number {
  return STATUS_TO_INT[status];
}

export interface OutgoingMessageDto {
  outgoingMessageId: number;
  groupId: number;
  mailboxId: number;
  mailboxEmailAddress?: string | null;
  senderName?: string | null;
  subject?: string | null;
  body?: string | null;
  htmlFormat?: boolean | null;
  status: number;
  statusDate?: string | null;
  errorMessage?: string | null;
  createDate: string;
  to?: string[] | null;
  cc?: string[] | null;
  bcc?: string[] | null;
  messageId?: number | null;
  replyToMessageId?: number | null;
}

export function outgoingMessageFromDto(dto: OutgoingMessageDto): OutgoingMessage {
  return {
    outgoingMessageId: dto.outgoingMessageId,
    groupId: dto.groupId,
    mailboxId: dto.mailboxId,
    mailboxEmailAddress: dto.mailboxEmailAddress ?? null,
    senderName: dto.senderName ?? null,
    subject: dto.subject ?? '',
    body: dto.body ?? '',
    htmlFormat: dto.htmlFormat ?? false,
    status: statusFromInt(dto.status),
    statusDate: dto.statusDate ?? null,
    errorMessage: dto.errorMessage ?? null,
    createDate: dto.createDate,
    to: dto.to ?? [],
    cc: dto.cc ?? [],
    bcc: dto.bcc ?? [],
    messageId: dto.messageId ?? null,
    replyToMessageId: dto.replyToMessageId ?? null,
  };
}
